export function getVideoUrl(mediaUrl: string) {
  const domain = mediaUrl.split("-")[0];
  const id = mediaUrl.substring(mediaUrl.indexOf("-") + 1);

  return [domain, id];
}
